<po-page-dynamic-edit
  [p-auto-router]="true"
  p-title="Cadastrar/Editar Códigos Internos"
  [p-actions]="actions"
  [p-breadcrumb]="breadcrumb"
  [p-fields]="fields"
  [p-service-api]="serviceApi"
>
</po-page-dynamic-edit>
